import { Col, Row } from "react-bootstrap";
import { AccordionPropsType } from "types/components/Accordion";
import AccordionItem from "./AccordionItem";
import styles from "./styles.module.scss";

const Accordion = ({ items, footer, headings, ...rest }: AccordionPropsType) => {
  return (
    <div data-testid="accordion" className={styles.accordion}>
      <div className={styles.accordionHeading}>
        <Row className={styles.accordionHeadingRow}>
          {headings?.map((heading) => (
            <Col xs={heading.xs}>
              <span data-testid="accordion-heading">{heading.title}</span>
            </Col>
          ))}
        </Row>
      </div>
      {items.map((itemProps, index) => (
        <AccordionItem key={index} headings={headings} {...rest} {...itemProps} />
      ))}
      {footer && (
        <div className={styles.accordionFooter} data-testid="accordion-footer">
          <span>{footer.title}</span>
          <span>{footer.value}</span>
        </div>
      )}
    </div>
  );
};

export default Accordion;
